import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { formatPercent } from "../../formatters/formatPercent";
export const FormatPercent = (props)=>{
    const formattedValue = formatPercent(props.value, props.options);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: formattedValue
    });
};
FormatPercent.displayName = 'FormatPercent';

//# sourceMappingURL=FormatPercent.js.map